window.StickerCovenConfigurator =
  window.StickerCovenConfigurator || {};

window.StickerCovenConfigurator.PricingEngine =
  class PricingEngine {
    getMaterialKey() {
      const pathname =
        window.location.pathname.toLowerCase();

      if (
        pathname.includes("holographic") ||
        pathname.includes("glitter")
      ) {
        return "holographic";
      }

      if (pathname.includes("clear")) {
        return "clear";
      }

      if (pathname.includes("economy")) {
        return "economy";
      }

      return "die-cut";
    }

    getDieCutAreaRate(area) {
      if (area >= 20) return 0.16;
      if (area >= 16) return 0.18;
      if (area >= 12) return 0.20;
      if (area >= 9) return 0.22;
      if (area >= 6) return 0.30;
      if (area >= 4) return 0.30;
      if (area >= 2) return 0.55;
      if (area >= 1) return 1.10;

      return 1.80;
    }

    getHolographicAreaRate(area) {
      if (area >= 20) return 0.25;
      if (area >= 16) return 0.26;
      if (area >= 12) return 0.325;
      if (area >= 9) return 0.347;
      if (area >= 6) return 0.43;
      if (area >= 4) return 0.475;
      if (area >= 2) return 0.95;
      if (area >= 1) return 1.90;

      return 7.60;
    }

    getClearAreaRate(area) {
      if (area >= 20) return 0.21;
      if (area >= 16) return 0.23;
      if (area >= 12) return 0.26;
      if (area >= 9) return 0.29;
      if (area >= 6) return 0.37;
      if (area >= 4) return 0.39;
      if (area >= 2) return 0.78;
      if (area >= 1) return 1.56;

      return 6.24;
    }

    getEconomyAreaRate(area) {
      if (area >= 20) return 0.10;
      if (area >= 16) return 0.12;
      if (area >= 12) return 0.13;
      if (area >= 9) return 0.14;
      if (area >= 6) return 0.20;
      if (area >= 4) return 0.20;
      if (area >= 2) return 0.36;
      if (area >= 1) return 0.72;

      return 1.17;
    }

    getAreaRate(area) {
      const material =
        this.getMaterialKey();

      if (material === "holographic") {
        return this.getHolographicAreaRate(
          area
        );
      }

      if (material === "clear") {
        return this.getClearAreaRate(
          area
        );
      }

      if (material === "economy") {
        return this.getEconomyAreaRate(
          area
        );
      }

      return this.getDieCutAreaRate(
        area
      );
    }

    getVolumeRate(quantity) {
      if (quantity > 9999) return 0.12;
      if (quantity > 4999) return 0.14;
      if (quantity > 2999) return 0.15;
      if (quantity > 1999) return 0.16;
      if (quantity > 999) return 0.18;
      if (quantity > 499) return 0.25;
      if (quantity > 249) return 0.32;
      if (quantity > 99) return 0.36;
      if (quantity > 49) return 0.52;
      if (quantity > 24) return 0.75;

      return 1;
    }

    calculate({
      width,
      height,
      quantity
    }) {
      if (
        !Number.isFinite(width) ||
        width <= 0
      ) {
        throw new Error(
          "Enter a valid sticker width."
        );
      }

      if (
        !Number.isFinite(height) ||
        height <= 0
      ) {
        throw new Error(
          "Enter a valid sticker height."
        );
      }

      if (
        !Number.isFinite(quantity) ||
        quantity < 1
      ) {
        throw new Error(
          "Select or enter a valid quantity."
        );
      }

      const area =
        width * height;

      const areaRate =
        this.getAreaRate(area);

      const volumeRate =
        this.getVolumeRate(quantity);

      const basePricePerSticker =
        Math.round(
          (
            area * areaRate +
            Number.EPSILON
          ) * 100
        ) / 100;

      const rawPrice =
        basePricePerSticker *
        quantity *
        volumeRate;

      const calculatedPrice =
        Math.round(
          (
            rawPrice +
            Number.EPSILON
          ) * 100
        ) / 100;

      const totalPrice =
        Math.max(
          10,
          calculatedPrice
        );

      const unitPrice =
        Math.round(
          (
            totalPrice / quantity +
            Number.EPSILON
          ) * 10000
        ) / 10000;

      return {
        width,
        height,
        quantity,
        area,
        areaRate,
        volumeRate,
        basePricePerSticker,
        totalPrice,
        unitPrice
      };
    }
  };